import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/semantic-platform/data-governance/quality/")({
  validateSearch: (search: Record<string, unknown>): { ns?: string } => {
    return typeof search.ns === "string" && search.ns ? { ns: search.ns } : {};
  },
  component: LegacyQualityRedirect,
});

/** 质量中心已并入分析中心（header 子 Tab：使用/影响/质量），承接引用健康度三色清单明细 */
function LegacyQualityRedirect() {
  const { ns } = Route.useSearch();
  return <Navigate to="/semantic-platform/data-governance/analysis" search={{ tab: "quality", ...(ns ? { ns } : {}) }} replace />;
}
